import { useBreakpoint } from 'components/BreakpointProvider';
import { mediaMMdMax, mediaMSmMax } from 'helpers/breakpoints';
import { useState } from 'react';
import Link from 'next/link';
import remove from 'lodash/remove';
import { useRouter } from 'next/router';
import styled, { css } from 'styled-components';
import { ColoredLink, LinkWrap } from 'components/header/shareComponents';
import useConversationDetail from 'components/inbox/hooks/useConversationDetail';
import { useEstimatedEarningsQuery } from 'components/blw/hooks';
import isEmpty from 'lodash/isEmpty';
import { useBoatDetails } from 'components/pdp/v3/hooks';
import { useUserDetails } from 'auth/mutations/userHooks';
import getConfig from 'next/config';
import boatsetterPaths from 'utils/boatsetterPaths';
import { getProfilePicFromUser } from 'utils/images';
import AuthLinks from 'components/headers/AuthLinks';
import AccountDropdownMenuItem from '../header/AccountDropdownMenuItem';
import { helpItemsBLW } from '../dropdownMenuData';
import SearchBar from '../SearchBar';
import ImpersonationMenuItem from '../ImpersonationMenuItem';
import NavInbox from '../header/NavInbox';
import GenericErrorBoundary from '../search/GenericErrorBoundary';
import { getAsString } from '../../helpers';
import ExtraDropdownMenu from '../header/ExtraDropdownMenu';
import HeaderDropdown from '../header/HeaderDropdown';
import { dollarsNoCentsWithSymbol } from '../../helpers/currency';

export const AdminConvoLink = ({ conversationId }) => (
  <a className="u-md-hide u-ml1_8" href={`/admin/conversations/${conversationId}`}>
    <svg fill="#102a5e" height={32} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1008 1008">
      <path d="M124 504v1.1c0-105.4 37.3-193.7 111.8-268.3C310.3 161.2 398.6 125 504 125s193.7 36.2 268.3 111.8C847.8 311.3 884 399.7 884 505.1c0 102.2-36.2 190.5-111.8 267.2C696.7 846.8 608.3 883 504 883c-105.4 0-193.7-36.2-268.3-110.7C161.2 696.7 124 608.3 124 504zm334.2-171.4h-1.1c36.2-9.6 56.4-9.6 92.6 0l86.2-86.2c-84.1-44.7-181-44.7-264 0l86.3 86.2zm-124.5-60.7l-63.9 62.8 79.8 79.8c16-25.5 37.3-46.8 62.8-63.9l-78.7-78.7zm259.7 78.8c26.6 17 46.8 38.3 62.8 63.9l79.8-79.8-63.9-62.8-78.7 78.7zm168.2 286.4v1.1c42.6-84.1 42.6-181 0-264l-86.2 85.2c8.5 30.9 8.5 60.7 0 91.5l86.2 86.2zm-517.3-263c-42.6 83-42.6 179.9 0 264l87.3-87.3c-4.3-16-6.4-30.9-6.4-44.7 0-17 2.1-33 6.4-46.8l-87.3-85.2zM469.9 587h-1.1c33 12.8 71.3 10.6 95.8-18.1 29.8-25.5 33-63.9 20.2-96.9-13.8-30.9-43.6-56.4-82-55.4-50 1.1-86.2 39.4-89.4 89.4-3.1 38.5 23.5 68.3 56.5 81zm-201.2 88.4l63.9 62.8 78.8-78.8c-24.5-13.8-45.8-35.1-62.8-63.9l-79.9 79.9zm402.4 62.8l63.9-62.8-79.8-79.8c-17 28.7-37.3 50-62.8 63.9l78.7 78.7zm-123.5-60.7h1.1c-36.2 9.6-56.4 9.6-92.6 0l-86.2 87.3c83 42.6 179.9 42.6 264 0l-86.3-87.3z" />
    </svg>
  </a>
);

export const AdminLink = ({ white, link }) => (
  <LinkWrap as="a" href={link}>
    <svg fill={white ? '#102a5e' : '#fff'} height={32} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1008 1008">
      <path d="M124 504v1.1c0-105.4 37.3-193.7 111.8-268.3C310.3 161.2 398.6 125 504 125s193.7 36.2 268.3 111.8C847.8 311.3 884 399.7 884 505.1c0 102.2-36.2 190.5-111.8 267.2C696.7 846.8 608.3 883 504 883c-105.4 0-193.7-36.2-268.3-110.7C161.2 696.7 124 608.3 124 504zm334.2-171.4h-1.1c36.2-9.6 56.4-9.6 92.6 0l86.2-86.2c-84.1-44.7-181-44.7-264 0l86.3 86.2zm-124.5-60.7l-63.9 62.8 79.8 79.8c16-25.5 37.3-46.8 62.8-63.9l-78.7-78.7zm259.7 78.8c26.6 17 46.8 38.3 62.8 63.9l79.8-79.8-63.9-62.8-78.7 78.7zm168.2 286.4v1.1c42.6-84.1 42.6-181 0-264l-86.2 85.2c8.5 30.9 8.5 60.7 0 91.5l86.2 86.2zm-517.3-263c-42.6 83-42.6 179.9 0 264l87.3-87.3c-4.3-16-6.4-30.9-6.4-44.7 0-17 2.1-33 6.4-46.8l-87.3-85.2zM469.9 587h-1.1c33 12.8 71.3 10.6 95.8-18.1 29.8-25.5 33-63.9 20.2-96.9-13.8-30.9-43.6-56.4-82-55.4-50 1.1-86.2 39.4-89.4 89.4-3.1 38.5 23.5 68.3 56.5 81zm-201.2 88.4l63.9 62.8 78.8-78.8c-24.5-13.8-45.8-35.1-62.8-63.9l-79.9 79.9zm402.4 62.8l63.9-62.8-79.8-79.8c-17 28.7-37.3 50-62.8 63.9l78.7 78.7zm-123.5-60.7h1.1c-36.2 9.6-56.4 9.6-92.6 0l-86.2 87.3c83 42.6 179.9 42.6 264 0l-86.3-87.3z" />
    </svg>
  </LinkWrap>
);

const { RAILS_URL } = getConfig().publicRuntimeConfig;
const baseURL = RAILS_URL.replace(/https?:\/\//, '');

const HomepageLogo = ({ fill }) => (
  <svg
    width="230"
    height="47"
    style={{ height: 32, width: 'auto' }}
    viewBox="0 0 230 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 23.3796C0 36.2787 10.4991 46.7592 23.4211 46.7592C36.3432 46.7592 46.8423 36.2787 46.8423 23.3796C46.8423 10.4805 36.3432 0 23.4211 0C10.4991 0 0 10.4805 0 23.3796ZM3.13975 23.3795C3.13975 12.272 12.2031 3.13514 23.4201 3.13514C34.6372 3.22472 43.6108 12.272 43.7005 23.3795C43.7005 23.5824 43.6975 23.7846 43.6916 23.986C41.7421 24.2544 39.8813 25.2373 38.4951 26.6939L38.4053 26.7835C37.5434 27.6439 36.4978 28.1864 35.4042 28.4111C35.9718 19.8652 31.7118 11.6654 24.2282 7.1662L23.4206 6.62874L22.6129 7.1662C15.218 11.6632 10.8825 19.8573 11.4369 28.3987C10.2598 28.1821 9.13835 27.612 8.25399 26.6939C6.88165 25.2519 5.10236 24.3322 3.15008 24.0282C3.14321 23.8128 3.13975 23.5965 3.13975 23.3795ZM23.4206 10.391C28.0516 13.5163 31.1182 18.3454 31.9998 23.6742C30.2373 20.2017 27.6133 17.209 24.3194 14.9593L23.422 14.3323L22.5246 14.9593C19.2642 17.1862 16.66 20.1411 14.8981 23.5686C15.8104 18.2816 18.8201 13.4956 23.4206 10.391ZM17.0252 26.445C20.5431 23.019 26.1068 23.0124 29.7009 26.4252L29.8236 26.5476C28.4635 23.2477 26.2776 20.3559 23.422 18.1841C20.5961 20.3334 18.3755 23.1877 17.0252 26.445ZM23.4201 43.624C33.2933 43.624 41.4979 36.6147 43.3221 27.2997C42.3623 27.583 41.4782 28.1053 40.7385 28.8438C39.1232 30.8145 36.7004 31.7998 34.1878 31.7998C31.6751 31.7998 29.342 30.8145 27.637 29.0229L27.5473 28.8438C25.2141 26.5148 21.4452 26.5148 19.2018 28.8438L19.1121 28.9333C15.6124 32.5164 9.86924 32.6956 6.27979 29.2021L6.01059 28.9333C5.35039 28.2194 4.48782 27.7075 3.54694 27.4182C5.42722 36.6183 13.598 43.624 23.4201 43.624ZM60.9306 6.71832V19.8861H61.0203C61.2895 19.5278 61.5588 19.1695 61.9177 18.9008C62.2766 18.5425 62.7253 18.2738 63.2637 18.005C64.5201 17.2884 65.9558 16.9301 67.3019 17.0197C69.8145 17.0197 72.1476 18.005 73.8526 19.8861C74.6602 20.7819 75.2884 21.8568 75.7371 23.0213C76.1858 24.2754 76.455 25.5295 76.3652 26.8731C76.3652 28.2168 76.1858 29.4709 75.7371 30.725C75.3781 31.8895 74.75 32.9644 73.9423 33.8602C73.1347 34.7559 72.1476 35.4725 71.0708 36.01C69.9042 36.5475 68.5582 36.8162 67.2121 36.8162C65.9558 36.8162 64.6098 36.5475 63.4432 35.9204C62.2766 35.383 61.3793 34.4872 60.7511 33.4123H60.6614V36.1892H56.1746V6.62874L60.9306 6.71832ZM71.6995 26.7836C71.6995 26.067 71.6098 25.3504 71.3406 24.6338C71.1611 23.9171 70.8021 23.2901 70.3535 22.6631C69.9048 22.1256 69.3664 21.5881 68.6485 21.3194C67.9306 20.9611 67.1229 20.7819 66.2256 20.7819C65.418 20.7819 64.6103 20.9611 63.8924 21.3194C63.2643 21.6777 62.6361 22.1256 62.1875 22.7526C61.7388 23.2901 61.2901 24.0067 61.1106 24.7233C60.8414 25.4399 60.7517 26.1566 60.7517 26.8732C60.7517 27.5898 60.8414 28.3064 61.1106 29.023C61.3798 29.7396 61.7388 30.3667 62.1875 30.9937C62.6361 31.5312 63.2643 32.0686 63.8924 32.3374C65.418 33.054 67.123 33.054 68.5587 32.3374C69.1869 31.9791 69.815 31.5312 70.2637 30.9041C70.7124 30.2771 71.0714 29.6501 71.2508 28.9335C71.6098 28.3064 71.6995 27.5898 71.6995 26.7836ZM78.9692 22.7526C78.4307 24.0067 78.1615 25.4399 78.1615 26.7835C78.1615 28.2168 78.4307 29.5604 78.9692 30.8145C79.4178 31.979 80.2255 33.0539 81.1228 33.9497C82.0202 34.8455 83.1868 35.5621 84.3533 36.01C86.9557 36.9953 89.7375 36.9953 92.3398 36.01C93.5064 35.5621 94.673 34.8455 95.5703 33.9497C96.4677 33.0539 97.1856 31.979 97.724 30.8145C98.2624 29.5604 98.5316 28.2168 98.5316 26.7835C98.5316 25.4399 98.2624 24.0067 97.724 22.7526C97.2753 21.5881 96.4677 20.5132 95.5703 19.6174C94.673 18.7216 93.5064 18.0946 92.3398 17.6467C89.7375 16.7509 86.9557 16.7509 84.3533 17.6467C83.1868 18.0946 82.0202 18.7216 81.1228 19.6174C80.2255 20.5132 79.5076 21.5881 78.9692 22.7526ZM83.2772 28.9334C83.008 28.2168 82.9182 27.5002 82.9182 26.7836C82.9182 26.067 83.008 25.3504 83.2772 24.6337C83.4567 23.9171 83.8156 23.2005 84.2643 22.663C84.713 22.1256 85.3411 21.6777 85.9693 21.3194C87.4948 20.6028 89.2895 20.6028 90.815 21.3194C91.5329 21.5881 92.0713 22.1256 92.52 22.663C92.9687 23.2901 93.3276 23.9171 93.5071 24.6337C93.7763 25.3504 93.8661 26.067 93.8661 26.7836C93.8661 27.5002 93.6866 28.2168 93.5071 28.9333L93.5071 28.9334C93.3276 29.6501 92.9687 30.2771 92.52 30.9041C92.0713 31.5312 91.4432 31.9791 90.815 32.3374C89.2895 33.054 87.4948 33.054 85.9693 32.3374C85.2514 31.9791 84.713 31.5312 84.2643 30.9041C83.8156 30.2771 83.4567 29.6501 83.2772 28.9334ZM112.798 33.8601H112.708C112.17 34.7558 111.362 35.4725 110.465 35.9203C109.388 36.4578 108.132 36.7265 106.875 36.7265C106.068 36.7265 105.26 36.637 104.542 36.4578C103.734 36.2786 102.927 35.9203 102.299 35.4725C101.581 35.0246 101.042 34.3975 100.594 33.6809C100.145 32.8747 99.8758 31.8894 99.8758 30.904C99.7861 29.65 100.235 28.4854 101.042 27.5001C101.94 26.6043 102.927 25.9773 104.093 25.619C105.439 25.1711 106.875 24.8128 108.221 24.7232C109.747 24.5441 111.272 24.5441 112.708 24.5441V24.0962C112.798 23.0212 112.259 22.0359 111.452 21.4984C110.554 20.961 109.478 20.6027 108.401 20.6922C107.414 20.6922 106.427 20.8714 105.529 21.3193C104.722 21.6776 103.914 22.2151 103.286 22.8421L100.863 19.9756C101.94 18.9903 103.196 18.1841 104.542 17.7362C105.888 17.2883 107.324 17.0196 108.76 17.0196C110.196 16.93 111.542 17.1987 112.888 17.7362C113.875 18.0945 114.772 18.7216 115.49 19.5277C116.118 20.2444 116.567 21.1401 116.836 22.0359C117.105 22.9317 117.195 23.917 117.195 24.8128V36.2786H112.888V33.8601H112.798ZM112.708 27.6792H111.631C110.913 27.6792 110.106 27.6792 109.208 27.7688C108.401 27.8584 107.683 27.948 106.875 28.2167C106.247 28.3959 105.619 28.6646 105.08 29.1125C104.632 29.5604 104.362 30.0978 104.362 30.8144C104.362 31.1727 104.452 31.6206 104.632 31.8894C104.811 32.1581 105.08 32.4268 105.439 32.606C105.798 32.7851 106.157 32.9643 106.516 32.9643C106.875 33.0539 107.324 33.0539 107.683 33.0539C109.029 33.1434 110.375 32.6956 111.362 31.7998C112.259 30.8144 112.708 29.5604 112.618 28.3063L112.708 27.6792ZM118.72 21.1401V17.557H122.04V12.0928H126.616V17.557H131.283V21.3193H126.616V30.0082C126.616 30.7249 126.706 31.4415 127.065 32.0685C127.514 32.6956 128.321 33.0539 129.039 32.8747C129.398 32.8747 129.757 32.8747 130.026 32.7851C130.206 32.7404 130.363 32.6956 130.52 32.6508L130.52 32.6508C130.677 32.606 130.834 32.5612 131.014 32.5164L131.193 36.1891C130.744 36.3682 130.206 36.4578 129.667 36.5474C129.129 36.6369 128.591 36.6369 128.052 36.6369C126.975 36.6369 125.988 36.4578 125.001 36.0995C124.283 35.8308 123.655 35.2933 123.117 34.6663C122.668 34.0392 122.399 33.3226 122.219 32.5164C122.04 31.7102 121.95 30.8144 121.95 29.9187V21.1401H118.72ZM143.668 21.0506C144.297 21.4089 144.925 21.8568 145.373 22.4839L148.424 19.707C147.617 18.7216 146.54 18.005 145.373 17.5571C144.117 17.1092 142.771 16.8405 141.425 16.8405C140.528 16.8405 139.63 16.9301 138.733 17.1988C137.836 17.378 137.028 17.7363 136.31 18.2737C135.592 18.8112 135.054 19.4382 134.605 20.1549C134.156 20.961 133.977 21.9464 133.977 22.8422C133.977 23.6484 134.067 24.365 134.426 25.0816C134.695 25.7086 135.144 26.2461 135.682 26.6044C136.22 27.0523 136.848 27.321 137.477 27.5897C138.195 27.8585 138.823 28.0376 139.541 28.2168C140.617 28.3959 141.694 28.7542 142.771 29.2021C143.489 29.4709 143.848 30.1875 143.848 30.9041C143.848 31.2624 143.758 31.6207 143.579 31.979C143.399 32.3373 143.13 32.5165 142.861 32.6956C142.502 32.8748 142.233 32.9644 141.874 33.0539C141.605 33.1435 141.246 33.1435 140.887 33.1435C139.9 33.2331 139.002 32.9644 138.105 32.5165C137.297 32.0686 136.579 31.5311 136.041 30.8145L132.99 33.681C133.887 34.6663 135.054 35.4725 136.4 35.9204C137.836 36.4579 139.271 36.7266 140.707 36.7266C141.694 36.7266 142.681 36.5475 143.668 36.3683C144.566 36.1891 145.463 35.8308 146.181 35.2934C146.899 34.7559 147.437 34.1289 147.886 33.3227C148.335 32.3373 148.514 31.352 148.514 30.3666C148.514 29.5604 148.335 28.7542 147.976 28.0376C147.617 27.4106 147.168 26.8731 146.54 26.4252L146.54 26.4252C145.912 26.0669 145.284 25.7086 144.566 25.4399C143.848 25.1712 143.13 24.992 142.412 24.8129C141.335 24.6337 140.348 24.2754 139.361 23.9171C138.643 23.7379 138.284 23.1109 138.284 22.3943C138.195 21.7672 138.553 21.1402 139.182 20.8715C139.81 20.6027 140.528 20.4236 141.246 20.4236C142.143 20.4236 142.951 20.6027 143.668 21.0506ZM169.064 27.7688V27.1418C169.064 25.619 168.795 24.0962 168.346 22.6629C167.987 21.4984 167.269 20.4235 166.461 19.5278C165.654 18.7216 164.667 18.0945 163.59 17.6466C162.423 17.1987 161.257 17.0196 160 17.0196C158.654 17.0196 157.308 17.2883 156.052 17.7362C153.719 18.632 151.745 20.5131 150.847 22.9317C150.309 24.2753 150.04 25.619 150.04 27.0522C150.04 28.4855 150.309 29.8291 150.847 31.1728C151.386 32.3373 152.104 33.3226 153.001 34.2184C153.898 35.1142 154.975 35.7412 156.142 36.1891C157.398 36.7265 158.834 36.9057 160.18 36.9057C163.68 36.9057 166.372 35.6516 168.256 33.1435L165.115 30.6353C164.667 31.3519 163.949 31.979 163.141 32.4268C162.244 32.8747 161.167 33.0539 160.18 33.0539C159.462 33.0539 158.834 32.9643 158.206 32.6956C157.577 32.4268 157.039 32.1581 156.501 31.7102C156.052 31.3519 155.603 30.8145 155.334 30.277C155.065 29.65 154.796 29.0229 154.796 28.3959H169.064V27.7688ZM164.129 23.29C164.308 23.8275 164.398 24.3649 164.398 24.992H154.796C154.886 23.7379 155.424 22.5734 156.412 21.7672C157.399 20.961 158.655 20.5131 160.001 20.5131C160.719 20.5131 161.347 20.6027 161.975 20.8714C162.962 21.3193 163.77 22.2151 164.129 23.29ZM169.511 21.1401V17.557H172.831V12.0928H177.407V17.557H181.804V21.3193H177.407V30.0082C177.407 30.7249 177.497 31.4415 177.856 32.0685C178.305 32.6956 179.112 33.0539 179.83 32.8747C180.189 32.8747 180.548 32.8747 180.817 32.7851C180.997 32.7403 181.154 32.6956 181.311 32.6508C181.468 32.606 181.625 32.5612 181.804 32.5164L181.984 36.1891C181.535 36.3682 180.997 36.4578 180.458 36.5474C179.92 36.6369 179.382 36.6369 178.843 36.6369C177.766 36.6369 176.779 36.4578 175.792 36.0995C175.074 35.8308 174.446 35.2933 173.908 34.6663C173.459 34.0392 173.19 33.3226 173.01 32.5164C172.831 31.7102 172.741 30.8144 172.741 29.9187V21.1401H169.511ZM182.074 21.1401V17.557H185.395V12.0928H190.061V17.557H194.727V21.3193H190.061V30.0083C190.061 30.7249 190.151 31.4415 190.51 32.0685C190.958 32.6956 191.766 33.0539 192.484 32.8747C192.843 32.8747 193.202 32.8747 193.471 32.7851C193.65 32.7404 193.807 32.6956 193.964 32.6509L193.964 32.6508L193.965 32.6507C194.122 32.6059 194.279 32.5612 194.458 32.5164L194.637 36.1891C194.189 36.3682 193.65 36.4578 193.112 36.5474C192.574 36.637 192.035 36.637 191.497 36.637C190.42 36.637 189.433 36.4578 188.446 36.0995C187.728 35.8308 187.1 35.2933 186.561 34.6663C186.113 34.0392 185.843 33.3226 185.664 32.5164C185.484 31.7102 185.395 30.8144 185.395 29.9187V21.1401H182.074ZM215.545 27.7688V27.1418C215.545 25.619 215.275 24.0962 214.737 22.6629C214.378 21.4984 213.66 20.4235 212.853 19.5278C212.045 18.7216 211.058 18.0945 209.981 17.6466C208.814 17.1987 207.648 17.0196 206.392 17.0196C205.046 17.0196 203.699 17.2883 202.443 17.7362C200.11 18.632 198.136 20.5131 197.238 22.9317C196.7 24.2753 196.431 25.619 196.431 27.0522C196.431 28.4855 196.7 29.8291 197.238 31.1728C197.777 32.3373 198.495 33.3226 199.392 34.2184C200.29 35.1142 201.366 35.7412 202.533 36.1891C203.789 36.7265 205.225 36.9057 206.571 36.9057C210.071 36.9057 212.763 35.6516 214.647 33.1435L211.507 30.6353C211.058 31.3519 210.34 31.979 209.532 32.4268C208.635 32.8747 207.558 33.0539 206.571 33.0539C205.853 33.0539 205.225 32.9643 204.597 32.6956C203.969 32.4268 203.43 32.1581 202.892 31.7102C201.905 30.904 201.277 29.65 201.187 28.3959H215.545V27.7688ZM210.52 23.29C210.7 23.8275 210.789 24.3649 210.789 24.992H201.188C201.277 23.7379 201.816 22.5734 202.803 21.7672C203.79 20.961 205.046 20.5131 206.392 20.5131C207.11 20.5131 207.738 20.6027 208.366 20.8714C209.354 21.3193 210.161 22.2151 210.52 23.29ZM222.815 17.557H218.328L218.418 36.189H223.084V26.1564C223.084 25.7085 223.174 25.2607 223.264 24.8128C223.443 24.1857 223.623 23.6483 223.982 23.1108C224.341 22.4838 224.879 22.0359 225.507 21.6776C226.315 21.3193 227.212 21.1401 228.11 21.1401H228.738C228.872 21.1849 229.007 21.2073 229.142 21.2297C229.276 21.2521 229.411 21.2745 229.545 21.3193V17.0196C229.366 16.93 229.187 16.93 229.007 16.93H228.379C227.212 16.8404 226.046 17.1987 225.059 17.9153C224.161 18.632 223.354 19.5277 222.905 20.6026H222.815V17.557Z"
      fill={fill}
    />
  </svg>
);

const SmallLogo = ({ fill }) => (
  <svg
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    width="32px"
    height="32px"
    viewBox="0 0 92 92"
    enableBackground="new 0 0 92 92"
  >
    <title>logo-bb-bs</title>
    <g id="Layer_2">
      <g id="Capa_2">
        <path
          fill={fill}
          d="M46.957,1.478c-24.877,0-45.043,20.166-45.043,45.043S22.08,91.565,46.957,91.565S92,71.398,92,46.522
                          C91.974,21.655,71.823,1.504,46.957,1.478z M46.957,85.429C28.549,85.404,12.668,72.503,8.873,54.49
                          c1.666,0.591,3.17,1.568,4.387,2.85c6.679,6.979,17.751,7.223,24.731,0.544c0.185-0.177,0.367-0.359,0.544-0.544l0.222-0.259
                          c4.446-4.452,11.66-4.457,16.112-0.01c0.003,0.003,0.007,0.007,0.01,0.01l0.241,0.278c6.676,6.982,17.749,7.23,24.731,0.553
                          c0.189-0.18,0.373-0.365,0.553-0.553c1.276-1.35,2.865-2.365,4.627-2.952C81.268,72.447,65.386,85.388,46.957,85.429z
                           M48.66,30.27l-1.703-1.138l-1.694,1.138c-6.324,4.242-11.429,10.065-14.808,16.89c1.75-10.438,7.704-19.701,16.474-25.627
                          C55.714,27.45,61.683,36.715,63.44,47.16C60.069,40.338,54.974,34.516,48.66,30.27z M59.303,52.889
                          c-6.694-6.853-17.659-7.03-24.571-0.398c2.57-6.301,6.782-11.798,12.198-15.918C52.462,40.783,56.741,46.425,59.303,52.889z
                           M85.809,47.928c-3.763,0.598-7.224,2.42-9.847,5.183c-1.593,1.685-3.669,2.835-5.942,3.295c0.056-0.925,0.102-1.851,0.102-2.776
                          c0.037-15.689-8.145-30.251-21.564-38.38l-1.601-0.981l-1.601,0.981c-13.423,8.137-21.602,22.711-21.554,38.407
                          c0,0.925,0.046,1.851,0.111,2.776c-2.389-0.41-4.583-1.578-6.256-3.332c-2.556-2.694-5.911-4.495-9.569-5.136
                          c0-0.481,0-0.925,0-1.444C8.088,25.031,25.509,7.609,47,7.609s38.91,17.422,38.91,38.913c-0.037,0.472-0.056,0.935-0.074,1.407
                          L85.809,47.928L85.809,47.928z"
        />
      </g>
    </g>
  </svg>
);

type HeaderProps = {
  searchOpen?: boolean;
  ownerNav?: boolean;
  captainNav?: boolean;
  isSearch?: boolean;
  hideNav?: boolean;
  white?: boolean;
  isPdp?: boolean;
  isHome?: boolean;
  menuOpen?: boolean;
  setMenuOpen?: (value: boolean) => void;
  isHomePage?: boolean;
  disableStickyHeader?: boolean;
};

const Header = ({
  searchOpen = false,
  ownerNav = false,
  captainNav = false,
  isSearch = false,
  hideNav = false,
  white,
  isPdp,
  isHome,
  menuOpen,
  setMenuOpen,
  isHomePage = false,
  disableStickyHeader = false,
}: HeaderProps) => {
  const { query, pathname, asPath } = useRouter();
  const [, setFalseHeader] = useState(false);

  const breakpoints = useBreakpoint();
  const smallScreen = breakpoints.xs || breakpoints.sm || breakpoints.md;

  const {
    data: { booking },
    conversationId,
  } = useConversationDetail();

  const { boatDetails } = useBoatDetails(getAsString(query.id));
  const { userDetails, isAuthenticated } = useUserDetails();

  const { data: { data: estimatedEarningsQuery } = {} } = useEstimatedEarningsQuery({
    make: boatDetails.make,
    boatModel: boatDetails.model,
    yearManufactured: boatDetails.year_manufactured,
    longitude: boatDetails.location?.lng,
    latitude: boatDetails.location?.lat,
    state: boatDetails.location?.state,
    countryCode: boatDetails.location?.country_code,
  });

  const isInboxPage = pathname.includes('inbox');

  const {
    first_name,
    id: userId,
    is_impersonating = false,
    is_admin,
    is_owner,
    is_boat_manager,
    is_captain,
  } = userDetails;

  const impersonateMenuItems = [
    {
      key: 'owner',
      name: `Impersonate Owner - ${booking?.owner?.first_name}`,
      target: `/impersonate/user/${booking?.owner?.id}`,
    },
    {
      key: 'renter',
      name: `Impersonate Renter - ${booking?.renter?.first_name}`,
      target: `/impersonate/user/${booking?.renter?.id}`,
    },
    {
      key: 'captain',
      name: `Impersonate Captain - ${booking?.captain?.first_name}`,
      target: `/impersonate/user/${booking?.captain?.id}`,
    },
  ];

  if (isEmpty(booking?.captain ?? {})) {
    remove(impersonateMenuItems, (e) => e.key === 'captain');
  }

  const bookings_default_path = () => {
    if (is_owner || is_boat_manager) {
      return `${boatsetterPaths.ownerDashboard}/bookings`;
    }
    if (is_captain) {
      return `${boatsetterPaths.captainDashboard}/bookings`;
    }
    return '/bookings';
  };

  const getAdminLink = ({ bookingId, id }) => {
    if (/\/bookings\/[a-z]+\/review/.test(asPath)) return `/admin/bookings/${bookingId}`;
    if (/\/bookings\/[a-z]+$/.test(asPath)) return `/admin/bookings/${bookingId}`;
    if (/\/boats\/[a-z]+/.test(asPath)) return `/admin/boats/${id}`;

    return '/admin/dashboard';
  };

  const logoFill = () => {
    if (ownerNav) {
      return '#0E7873';
    }

    if (captainNav) {
      return '#00677D';
    }

    if (isBLW) {
      return 'white';
    }

    return '#0A4195';
  };

  const saveAndExit = async () => {
    window.location.href = boatsetterPaths.ownerDashboard;
  };

  const smallLogo = (isSearch || isAuthenticated) && smallScreen && !menuOpen;

  const isBLWHomepage = pathname === boatsetterPaths.listBoat;
  const isBLWPage = !isBLWHomepage && pathname.includes(boatsetterPaths.listBoat);

  const isBLW = isBLWPage || isBLWHomepage;
  const isHomepage = pathname === '/';

  return (
    <Wrapper
      $disableSticky={isHomepage || disableStickyHeader}
      $white={white}
      $isSearch={isSearch}
      $isPdp={isPdp}
      $isBLW={isBLW}
      $owner={!!ownerNav}
      $captain={!!captainNav}
      id="js-nav-top"
    >
      <LogoWrapper $smallLogo={smallLogo}>
        <Link passHref href="/" legacyBehavior>
          <FlexLink>{smallLogo ? <SmallLogo fill={logoFill()} /> : <HomepageLogo fill={logoFill()} />}</FlexLink>
        </Link>
      </LogoWrapper>
      {isSearch && !menuOpen && (
        <SearchWrapper data-testid="components-headers-SearchWrapper">
          <GenericErrorBoundary>
            <SearchBar setFalseHeader={setFalseHeader} white={white} searchOpen={!menuOpen} captainNav={captainNav} />
          </GenericErrorBoundary>
        </SearchWrapper>
      )}
      {!hideNav && !menuOpen && !(isSearch && smallScreen) && (
        <RightNavSide>
          {is_admin && isInboxPage && conversationId !== '' && <AdminConvoLink conversationId={conversationId} />}

          {is_admin && !isInboxPage && (
            <AdminLink white={white ? '#102a5e' : '#fff'} link={getAdminLink(query as any)} />
          )}
          {isHomePage && !smallScreen && (
            <ExtraDropdownMenu isAnonymous={!isAuthenticated} isAdmin={is_admin} isCaptain={captainNav} />
          )}
          {!searchOpen &&
            (!userId ? (
              <>
                {isHome && (
                  <LinkWrapDesktopOnly>
                    <ColoredLink>
                      <Link prefetch={false} href={boatsetterPaths.listBoat}>
                        List your boat
                      </Link>
                    </ColoredLink>
                  </LinkWrapDesktopOnly>
                )}
                {((!isSearch && !menuOpen) || (isSearch && !smallScreen)) && (
                  <AuthLinks
                    onSignup={() => {
                      setMenuOpen(false);
                    }}
                    onLogin={() => {
                      setMenuOpen(false);
                    }}
                  />
                )}

                {isHome && (
                  <>
                    <LinkWrapDesktopOnly>
                      <ColoredLink>
                        <Link href={boatsetterPaths.aboutUs}>About us</Link>
                      </ColoredLink>
                    </LinkWrapDesktopOnly>
                    <LinkWrapDesktopOnly>
                      <ColoredLink>
                        <a
                          rel="noopener noreferrer"
                          target="_blank"
                          href={`https://support.boatsetter.com?utm_source=${baseURL}&utm_medium=referral`}
                        >
                          Support
                        </a>
                      </ColoredLink>
                    </LinkWrapDesktopOnly>
                  </>
                )}
              </>
            ) : (
              <>
                {is_admin && !is_impersonating && isInboxPage && booking && (
                  <LinkWrap>
                    <HeaderDropdown
                      icon={
                        <svg
                          height={32}
                          fill={white ? '#102a5e' : '#fff'}
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 1008 1008"
                        >
                          <path d="M766.6 523.6L765 522c6.2-7.8 10.9-14.8 14.8-21.1 3.9-6.2 3.9-10.9 0-14-32-28.9-65.6-39.8-99.9-32.8-14 3.1-27.3 9.4-40.6 18.7-18.7 14-33.6 31.2-44.5 50.7-2.3 4.7-1.6 8.6 2.3 11.7 32 28.9 65.6 39.8 99.9 32.8 14-3.1 27.3-9.4 40.6-18.7 13.4-9.3 22.8-17.8 29-25.7zm-352.7 12.5c3.9-3.1 4.7-7 2.3-11.7-22.6-39-50.7-62.4-85.1-69.5s-67.9 3.9-99.9 32.8c-3.9 3.1-4.7 7-2.3 11.7 22.6 39 50.7 62.4 85.1 69.5s67.9-3.9 99.9-32.8zm454.2-217.7l2.3 3.1c7 5.5 10.9 15.6 12.5 29.7 1.6 14 3.9 39 6.2 74.9 6.2 89.7 9.4 143.6 9.4 161.5 0 10.9-12.5 25-37.5 42.1-25 17.2-56.2 32-94.4 45.3-38.2 13.3-72.6 20.3-103.8 20.3-25.8 0-47.6-7-66.3-21.1-14.8-11.7-27.3-24.2-36.7-36.7-9.4-12.5-16.4-21.9-21.9-28.1-11.7-14-22.6-21.1-32.8-21.1-9.4 0-17.2 3.9-24.2 11.7-7 7.8-13.3 14.8-18.7 21.1-5.5 6.2-10.9 12.5-16.4 19.5-5.5 7-11.7 13.3-18.7 19.5s-14 11.7-21.9 16.4c-16.3 11-38.2 16.5-65.5 16.5-27.3 0-60.1-7-98.3-20.3-38.2-13.3-69.5-28.1-94.4-45.3s-37.5-31.2-37.5-42.9 2.3-47.6 6.2-107.7 7-105.4 10.1-135.8c.8-9.4 4.7-17.2 11.7-22.6 7-5.5 16.4-7 28.9-4.7s40.6 10.1 84.3 23.4c43.7 13.3 88.2 25 134.2 35.9 46 10.9 85.1 16.4 117.8 16.4s71.8-5.5 117.8-16.4c46-10.9 90.5-22.6 134.2-35.9 43.7-13.3 71.8-21.1 84.3-23.4s22-.8 29.1 4.7z" />
                        </svg>
                      }
                    >
                      <ImpersonateWrapper>
                        {impersonateMenuItems.map((i) => (
                          <a key={i.key} href={i.target}>
                            {i.name}
                          </a>
                        ))}
                      </ImpersonateWrapper>
                    </HeaderDropdown>
                  </LinkWrap>
                )}
                {is_impersonating && (
                  <LinkWrap>
                    <ImpersonationMenuItem userDetails={userDetails} />
                  </LinkWrap>
                )}

                {isBLWPage && (estimatedEarningsQuery as any)?.estimated_earnings > 0 && (
                  <>
                    <EstimatedWrapper>
                      <Estimated>Estimated monthly earnings:</Estimated>
                      <EstimatedValue>
                        {dollarsNoCentsWithSymbol((estimatedEarningsQuery as any)?.estimated_earnings)}
                      </EstimatedValue>
                    </EstimatedWrapper>
                    <HeaderDropdown icon={<LinkWrap white>Support</LinkWrap>}>
                      <SupportDropDown>
                        {helpItemsBLW.map((i) => (
                          <a key={i.target} href={i.target}>
                            {i.name}
                          </a>
                        ))}
                        {/* todo colors */}
                      </SupportDropDown>
                    </HeaderDropdown>
                    <LinkWrap white data-testid="components-header-blw-save-and-exit-link">
                      <a href="#" onClick={saveAndExit}>
                        Save and exit
                      </a>
                    </LinkWrap>
                  </>
                )}

                {!isSearch && !menuOpen && !isBLWPage && (
                  <>
                    {!isBLWHomepage && !smallScreen && (
                      <LinkWrap>
                        <ColoredLink>
                          <Link passHref href={boatsetterPaths.listBoat}>
                            List your boat
                          </Link>
                        </ColoredLink>
                      </LinkWrap>
                    )}
                    <LinkWrap>
                      <NavInbox userDetails={userDetails} />
                    </LinkWrap>

                    <LinkWrap>
                      <ColoredLink>
                        <Link prefetch={false} passHref href={bookings_default_path()} rel="nofollow">
                          Bookings
                        </Link>
                      </ColoredLink>
                    </LinkWrap>
                  </>
                )}

                {!smallScreen && !isBLWPage && (
                  <AccountDropdownMenuItem
                    title={first_name}
                    isAuthenticated={isAuthenticated}
                    userDetails={userDetails}
                    image={getProfilePicFromUser(userDetails)}
                    data-testid="user-photo"
                    isOwner={!!ownerNav}
                    isCaptain={!!captainNav}
                    isSearch={isSearch}
                  />
                )}
              </>
            ))}
        </RightNavSide>
      )}
      {!hideNav && smallScreen && !isBLWPage && (
        <HamburgerMenu
          onClick={() => setMenuOpen(!menuOpen)}
          data-testid="components-headers-hamburger-menu"
          $menuOpen={menuOpen}
          aria-controls="js-nav-top"
          aria-label="Toggle navigation"
          $isSearch={isSearch}
        >
          {menuOpen ? (
            <CloseIcon $isBLWPage={isBLW}>
              <svg height={15} fill={logoFill()} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1008 1008">
                <path d="M227.8 157.3l633.9 633.9c19.5 19.5 19.5 51 0 70.4-19.5 19.5-51 19.5-70.4 0l-634-633.8c-19.5-19.5-19.5-51 0-70.4 19.5-19.5 51-19.5 70.5-.1z" />
                <path d="M146.3 780.2l633.9-633.9c19.5-19.5 51-19.5 70.4 0 19.5 19.5 19.5 51 0 70.4l-633.9 634c-19.5 19.5-51 19.5-70.4 0-19.5-19.5-19.5-51 0-70.5z" />
              </svg>
            </CloseIcon>
          ) : (
            <svg height={20} fill={logoFill()} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1008 1008">
              <path d="M132.8 193.9h742.4c22.8 0 41.2 19.8 41.2 44.3 0 24.5-18.5 44.3-41.2 44.3H132.8c-22.8 0-41.2-19.8-41.2-44.3-.1-24.5 18.4-44.3 41.2-44.3zM132.8 459.7h742.4c22.8 0 41.2 19.8 41.2 44.3 0 24.5-18.5 44.3-41.2 44.3H132.8c-22.8 0-41.2-19.8-41.2-44.3-.1-24.5 18.4-44.3 41.2-44.3zM132.8 725.5h742.4c22.8 0 41.2 19.8 41.2 44.3 0 24.5-18.5 44.3-41.2 44.3H132.8c-22.8 0-41.2-19.8-41.2-44.3-.1-24.5 18.4-44.3 41.2-44.3z" />
            </svg>
          )}
        </HamburgerMenu>
      )}
    </Wrapper>
  );
};

const EstimatedWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  font-size: 14px;

  ${mediaMMdMax} {
    font-size: 12px;
    position: absolute;
    left: 0;
    top: 60px;
    width: 100%;
    padding: 0.5em 1.1em !important;
    background: #0f605c;
  }
`;

const Estimated = styled.div`
  color: white;
`;

const EstimatedValue = styled.div`
  color: #f4c064;
  font-weight: 700;
`;

const SupportDropDown = styled.div`
  display: flex;
  flex-flow: column;
  gap: 10px;
`;

const FlexLink = styled.a`
  display: flex;
  align-items: center;
`;

const CloseIcon = styled.div<{ $isBLWPage?: boolean }>`
  background: ${({ $isBLWPage }) => ($isBLWPage ? '' : '#F5F7F9')};
  font-size: ${({ $isBLWPage }) => ($isBLWPage ? '22px' : '15px')};
  height: 32px;
  width: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;

  ${({ $isBLWPage }) =>
    $isBLWPage &&
    css`
      i {
        color: white !important;
        font-size: 22px !important;
      }
    `}

  i {
    color: rgb(94, 105, 106);
    font-size: 15px;
    margin-top: 2px;
  }
`;

const ImpersonateWrapper = styled.div`
  display: flex;
  flex-flow: column;
  min-width: 300px;
`;

const LogoWrapper = styled.div<{ $smallLogo: boolean }>`
  display: flex;

  ${({ $smallLogo }) =>
    !$smallLogo &&
    css`
      ${mediaMSmMax} {
        width: 35%;
      }
    `}

  align-items: center;

  a {
    width: 100%;
  }

  a {
    line-height: 0;
  }
`;

const RightNavSide = styled.div`
  display: flex;
`;

const HamburgerMenu = styled.div<{ $menuOpen: boolean; $isSearch: boolean }>`
  display: flex;
  align-items: center;
  margin-left: 50px;

  ${mediaMMdMax} {
    margin-left: ${({ $menuOpen }) => ($menuOpen ? 'auto' : '20px')};
    ${({ $isSearch }) =>
      $isSearch &&
      css`
        margin-left: 0;
      `}
  }
`;

const SearchWrapper = styled.div`
  display: flex;
  position: relative;

  ${mediaMSmMax} {
    position: initial;
    max-width: 300px;
    width: 100%;
  }
`;

const LinkWrapDesktopOnly = styled(LinkWrap)`
  ${mediaMMdMax} {
    display: none;
  }
`;

const Wrapper = styled.div<{
  $disableSticky: boolean;
  $isPdp: boolean;
  $isSearch: boolean;
  $owner: boolean;
  $captain: boolean;
  $isBLW: boolean;
  $white: boolean;
}>`
  position: fixed;
  top: 0;
  z-index: 1000;
  padding: 10px 32px;
  height: 60px;
  display: flex;
  width: 100%;
  background: white;
  box-shadow: 0 0 11px rgb(0 0 0 / 10%);
  border-bottom: 1px solid #eaebeb;

  ${({ $disableSticky }) =>
    $disableSticky &&
    css`
      position: unset;
    `}

  ${({ $isPdp }) =>
    $isPdp &&
    css`
      border-bottom: none;
      box-shadow: none;
      position: initial;
      ${mediaMMdMax} {
        display: none;
      }
    `}

  ${RightNavSide} {
    margin-left: auto;
  }

  ${({ $isSearch }) =>
    $isSearch &&
    css`
      justify-content: space-between;
      gap: 5px;

      ${mediaMMdMax} {
        align-items: center;
      }

      ${RightNavSide} {
        margin-left: initial;
      }
    `}

  ${LinkWrap} a {
    line-height: 1.714285;
    color: #0a4195;
    font-weight: 500;

    ${mediaMMdMax} {
      font-weight: 500;
    }
  }

  ${({ $owner }) =>
    $owner &&
    css`
      ${ColoredLink} a {
        color: #0e7873 !important;
      }
    `}

  ${({ $captain }) =>
    $captain &&
    css`
      ${ColoredLink} a {
        color: #00677d !important;
      }
    `}

  ${({ $isBLW }) =>
    $isBLW &&
    css`
      background: #0e7873;
      border-bottom: none;

      #accountDropdownMenu ${ColoredLink} a {
        color: #0e7873 !important;
      }

      ${ColoredLink} a {
        color: white !important;
      }
    `}

  ${({ $white }) =>
    $white &&
    css`
      background: white;

      ${ColoredLink} a {
        color: #0a4195;
      }
    `}

  ${mediaMMdMax} {
    padding: 15px 20px;
    min-height: 0;
    border-bottom: 1px solid #eaebeb;
  }
`;

export default Header;
